"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _validate = require("@/utils/validate");
var _enum = require("../../enum");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var props = {
  children: 'child',
  label: 'name',
  value: 'id',
  emitPath: false
};
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'input',
    label: '促销名称：',
    prop: 'name',
    attrs: {
      placeholder: '请输入促销名称',
      clearable: true
    },
    events: {
      input: (0, _validate.Debounce)(function (value) {
        return handleSearch({
          name: value
        });
      })
    }
  }, {
    type: 'picker',
    label: '有效期：',
    prop: 'lifespanTime',
    attrs: {
      placeholder: '请选择',
      type: 'datetimerange',
      clearable: true,
      'start-placeholder': "开始日期",
      'end-placeholder': "结束日期",
      'value-format': 'yyyy-MM-dd HH:mm:ss'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          lifespanTime: value
        });
      }
    }
  }];
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}